import swap from 'components/ui/CurrencyIcon/images/swap.svg'
import btc from 'components/ui/CurrencyIcon/images/btc.svg'
import eth from 'components/ui/CurrencyIcon/images/eth.svg'
import usdt from 'components/ui/CurrencyIcon/images/usdt.svg'

import withoutSecure from './withoutSecure.svg'
import sms from './sms.svg'
import pin from './pin.svg'
import google2FA from './google2FA.svg'
import multisignature from './multisignature.svg'
import fingerprint from './fingerprint.svg'


export default {
  btc,
  swap,
  eth,
  usdt,
  withoutSecure,
  sms,
  pin,
  google2FA,
  multisignature,
  fingerprint,
}
